import { message } from '@payflip/ui/v2';
import { EmailNotVerifiedPage as BasePage, useAuth } from '@payflip/web/auth';
import { useContext } from 'react';
import { toast } from 'react-toastify';
import { LocaleContext } from '../../components/locale-provider';
import { useResendVerificationEmailMutation } from './mutations.generated';
import { useGetEmailNotVerifiedPageLocalesQuery } from './queries.cms.generated';

export function EmailNotVerifiedPage(): JSX.Element {
  const { locale } = useContext(LocaleContext);
  const { data: cms } = useGetEmailNotVerifiedPageLocalesQuery({ locale });
  const content = cms?.common?.data?.attributes;
  const [resendEmail, { loading }] = useResendVerificationEmailMutation();
  const { auth0User } = useAuth();

  const email =
    auth0User?.['https://sso.payflip.be/upn'] ?? (auth0User?.email as string);

  const resendVerificationEmail = async (): Promise<void> => {
    try {
      await resendEmail();
      toast.success(
        message(
          content?.emailNotVerifiedResendSuccess,
          `Verification email sent to ${email}`,
          { email }
        )
      );
    } catch (error) {
      toast.error(
        message(
          content?.emailNotVerifiedResendError,
          'Failed to resend verification email'
        )
      );
    }
  };

  return (
    <BasePage
      onResendEmail={resendVerificationEmail}
      isLoading={loading}
      header={message(
        content?.emailNotVerifiedHeader,
        'Just one more step, verify your email'
      )}
      body={message(
        content?.emailNotVerifiedBody,
        "We've sent a verification mail to <b>{{email}}</b>. Please check your inbox and accept your invitation to Payflip.",
        { email: email as string }
      )}
      footer={message(
        content?.emailNotVerifiedFooter,
        "Didn't receive an email? Check your spam or"
      )}
      resendButtonLabel={message(
        content?.emailNotVerifiedResend,
        'Resend email'
      )}
      logoutDescription={message(
        content?.logoutDescription,
        'Want to log in with another account?'
      )}
      logoutButtonLabel={message(content?.logoutButton, 'Log out')}
    />
  );
}
